import { useS } from '../store/game';
import { pub } from '../engine/opinion';
import { trendFor } from '../engine/zeitgeist';

/** Wie hat sich die Stimmung zu einem Programmthema seit der letzten Wahl bewegt, relativ zur Position y? */
export function TrendNote({ a, y }: { a: string; y: number }) {
  const S = useS(); if (!S.pubE) return null;
  const t = trendFor(a, y, pub(a));
  const mv = Math.abs(t.d) < .1 ? 'kaum verändert' : t.d > 0 ? `↑ mehr Zustimmung` : `↓ mehr Ablehnung`;
  return <span className="sub">Stimmung seit der Wahl: {mv}{Math.abs(y) < 1 ? null : t.dir === 'zu' ? <b className="up"> · läuft für euch</b> : t.dir === 'weg' ? <b className="down"> · läuft gegen euch</b> : null}</span>;
}
